import type { FC } from 'react'
import { useEffect } from 'react'

import { AuthClient } from '@skytech/auth'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useLocation, useNavigate } from 'react-router-dom'

import authResources from '@/resources/auth'
import { commonQueries } from '@/resources/queries'
import { APP_ROUTES } from '@/util/app-routes'

const Logout: FC = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const location = useLocation()

  // mutation from react-query
  const { mutate } = useMutation(authResources.deleteRefreshToken, {
    onSuccess() {
      const queryCache = queryClient.getQueryCache()
      queryCache.getAll().forEach(({ queryKey }) => {
        if (queryKey === commonQueries.translationList()) return
        queryClient.removeQueries(queryKey)
      })

      const searchParams = new URLSearchParams(location.search)
      const nextParam = searchParams.get('next')
      const azureErrorMsgParam = searchParams.get('azureErrorMsg')
      const search = nextParam || azureErrorMsgParam ? `?${searchParams}` : ''
      navigate(APP_ROUTES.LOGIN + search)
    },
  })

  useEffect(() => {
    AuthClient.removeToken()
    mutate()
  }, [mutate])
  return null
}

export default Logout
